import React, { useEffect } from 'react'
import { useRouter } from 'next/router'
import { observer } from 'mobx-react-lite'
import StatusStore from 'stores/status'
import { useStore } from 'hooks'

import ClientOnly from 'components/ClientOnly'
import LoadingContainer from 'components/LoadingContainer'

const GeoLocationContainer = ({ countryCode = 'US', redirectUrl = '/', children }) => {
  const statusStore = useStore(StatusStore)
  const router = useRouter()

  useEffect(() => {
    statusStore.find().then(() => {
      if (statusStore.current?.client?.geo?.countryCode !== countryCode) {
        router.push(redirectUrl)
      }
    })
  }, [])

  return (
    <ClientOnly>
      <LoadingContainer isLoading={statusStore.isLoading} delay={250}>
        {children}
      </LoadingContainer>
    </ClientOnly>
  )
}

export default observer(GeoLocationContainer)
